module.exports = __webpack_public_path__ + "img/img_works04.e35be1e1.jpg";